import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M14.4 12.03c0 1.289-1.075 2.335-2.4 2.335s-2.4-1.046-2.4-2.336 1.075-2.335 2.4-2.335c1.326 0 2.4 1.045 2.4 2.335Z"
    />
  </svg>
);
export default SvgEyeOpen;
